import { render, staticRenderFns } from "./BackofficeTotais.vue?vue&type=template&id=110a4842"
import script from "./BackofficeTotais.vue?vue&type=script&lang=js"
export * from "./BackofficeTotais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports